// src/data/Reconnect_GG_RE01.js
import React from 'react';
import feedImg from '../assets/ash/DC_breach_camA2_ksw.webp';

/* security‑feed overlay component */
const SecurityFeedOverlay01 = () => (
  <div className="security-feed-container">
    <img src={feedImg} alt="Security Feed" className="ash-feed" />

    <div className="security-overlay">
      {/* header */}
      <div className="security-header">
        <div className="header-line pink-text">[SECURITY FEED RECONNECTED]</div>
        <div className="header-line white-text">[SOURCE: UNVERIFIED UPLINK NODE]</div>
      </div>

      {/* footer */}
      <div className="bottom-section">
        <div className="security-footer">
          <div className="footer-left">
            <span className="white-text">USER:</span> <span className="pink-text">KSW</span>
          </div>
          <div className="footer-right">
            <span className="white-text">UNION LOGGING:</span> <span className="red-text">OFFLINE</span>
          </div>
        </div>

        <div className="threat-info">
          <div className="threat-divider"></div>
          <div className="threat-line">
            <span className="white-text">Threat Level:</span> <span className="pink-text">Cognitively Hazardous</span>
          </div>
          <div className="threat-line">
            <span className="white-text">Containment Status:</span> <span className="pink-text">Unchanged</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ---- reconnect #1 message set ---- */
export const reconnect1Data = [
  /* CAPS + animated dots */
  {
    content: [
      { text: "CONNECTION RE-ESTABLISHED", delay: 0 },
      { text: ".", delay: 200 },
      { text: ".", delay: 200 },
      { text: ".", delay: 400 }
    ],
    type: "stream",
    cursorDuration: 700,
    showPrefix: false
  },

  /* ASH control line (black bold + red bold) */
  {
    content: [ 
      { text: "ASH system control: ", delay: 0, className: "highlight-bold" },
      { text: "Suspended, by unknown protocol.", delay: 100, className: "highlight-fail" }
    ],
    delay: 600,
    type: "stream",
    cursorDuration: 800
  },

  { content: " ", delay: 200, type: "bracket" },

  /* Security‑feed image */
  { content: <SecurityFeedOverlay01 />, delay: 800, type: "image" },

  { content: "----------------------------------------", delay: 300, type: "bracket" },

  {
    content: "— DIGITAL CALAMARI SYSTEM OVERRIDE MAINTAINED —",
    delay: 700,
    type: "bracket",
    className: "highlight-hack override"
  },

  {
    content: [
      { text: "Back again?", delay: 0, className: "highlight-bold" },
      { text: " Good.", delay: 500, className: "highlight-bold" },
      { text: " You know where everything is.", delay: 1000, className: "highlight-bold" },
      { text: " No need to go through the whole song and dance again....", delay: 1000, className: "highlight-bold" },
      { text: " A SIGHT FOR SORE EYES TO THE BLIND, WOULD B..", delay: 1600, className: "highlight-bold" },
      { text: " Aw..", delay: 2100, className: "highlight-bold" },
      { text: " for fucks sake.", delay: 2250, className: "highlight-bold" }

    ],
    type: "stream",
    cursorDuration: 3000,
    showPrefix: false
  },

  { content: "[ CONTINUE TO ARCHIVE ]", delay: 600, type: "button" }
];